import { PPRD, Text } from "@/components";

export const SavesYou = () => {
  return (
    <div className="container mx-auto">
      <div className="mx-auto max-w-screen-xl flex flex-col items-center gap-6 md:gap-10">
        <Text.Heading className="text-white md:px-[100px] text-center">
          <span>
            An equity management concierge that&nbsp;
            <span className="text-secondary">saves you time & money</span>
          </span>
        </Text.Heading>

        <div className="text-xl md:text-2xl text-center">
          Effortlessly manage your cap table via email. Simply send us a
          request, and we'll handle the rest. This gives you more time to focus
          on growing your business while saving you thousands in legal fees
        </div>

        <PPRD />
      </div>
    </div>
  );
};
